import ChevronUp from "./ChevronUp";
import OutlineArchive from "./OutlineArchive";
import OutlineArrowUpRight from "./OutlineArrowUpRight";
import OutlineChartPie from "./OutlineChartPie";
import OutlineEdit from "./OutlineEdit";
import OutlineEye from "./OutlineEye";
import OutlineEyeSlash from "./OutlineEyeSlash";
import OutlineExclamation from "./OutlineExclamation";
import OutlineHome from "./OutlineHome";
import SolidArchive from "./SolidArchive";
import SolidCheckCircle from "./SolidCheckCircle";
import SolidBadgeInfo from "./SolidBadgeInfo";
import SolidCircleMinus from "./SolidCircleMinus";
import SolidClipboard from "./SolidClipboard";
import SolidClipboardList from "./SolidClipboardList";
import SolidClock from "./SolidClock";
import SolidCloseCircle from "./SolidCloseCircle";
import SolidCodeFork from "./SolidCodeFork";
import SolidDesktopPC from "./SolidDesktopPC";
import SolidEdit from "./SolidEdit";
import SolidEye from "./SolidEye";
import SolidFileClone from "./SolidFileClone";
import SolidFileZip from "./SolidFileZip";
import SolidGlobe from "./SolidGlobe";
import SolidHome from "./SolidHome";
import SolidRocket from "./SolidRocket";
import SolidTag from "./SolidTag";
import TrashBin from "./TrashBin";

export type IconTypes =
  | "chevron-up"
  | "outline-archive"
  | "outline-arrow-up-right"
  | "outline-chart-pie"
  | "outline-edit"
  | "outline-exclamation"
  | "outline-eye"
  | "outline-eye-slash"
  | "outline-home"
  | "solid-archive"
  | "solid-badge-info"
  | "solid-check-circle"
  | "solid-circle-minus"
  | "solid-clipboard"
  | "solid-clipboard-list"
  | "solid-clock"
  | "solid-close-circle"
  | "solid-code-fork"
  | "solid-desktop-pc"
  | "solid-edit"
  | "solid-eye"
  | "solid-file-clone"
  | "solid-file-zip"
  | "solid-globe"
  | "solid-home"
  | "solid-rocket"
  | "solid-tag"
  | "trash-bin";

const Icon = ({
  classNames,
  type,
}: {
  classNames: string;
  type: IconTypes;
}) => {
  switch (type) {
    case "chevron-up":
      return <ChevronUp classNames={classNames} />;
    case "outline-archive":
      return <OutlineArchive classNames={classNames} />;
    case "outline-arrow-up-right":
      return <OutlineArrowUpRight classNames={classNames} />;
    case "outline-chart-pie":
      return <OutlineChartPie classNames={classNames} />;
    case "outline-edit":
      return <OutlineEdit classNames={classNames} />;
    case "outline-exclamation":
      return <OutlineExclamation classNames={classNames} />;
    case "outline-eye":
      return <OutlineEye classNames={classNames} />;
    case "outline-eye-slash":
      return <OutlineEyeSlash classNames={classNames} />;
    case "outline-home":
      return <OutlineHome className={classNames} />;
    case "solid-archive":
      return <SolidArchive classNames={classNames} />;
    case "solid-check-circle":
      return <SolidCheckCircle classNames={classNames} />;
    case "solid-circle-minus":
      return <SolidCircleMinus classNames={classNames} />;
    case "solid-clipboard":
      return <SolidClipboard classNames={classNames} />;
    case "solid-clipboard-list":
      return <SolidClipboardList classNames={classNames} />;
    case "solid-clock":
      return <SolidClock classNames={classNames} />;
    case "solid-close-circle":
      return <SolidCloseCircle classNames={classNames} />;
    case "solid-code-fork":
      return <SolidCodeFork classNames={classNames} />;
    case "solid-desktop-pc":
      return <SolidDesktopPC classNames={classNames} />;
    case "solid-edit":
      return <SolidEdit classNames={classNames} />;
    case "solid-eye":
      return <SolidEye classNames={classNames} />;
    case "solid-file-clone":
      return <SolidFileClone classNames={classNames} />;
    case "solid-file-zip":
      return <SolidFileZip classNames={classNames} />;
    case "solid-globe":
      return <SolidGlobe classNames={classNames} />;
    case "solid-home":
      return <SolidHome classNames={classNames} />;
    case "solid-rocket":
      return <SolidRocket classNames={classNames} />;
    case "solid-tag":
      return <SolidTag classNames={classNames} />;
    case "trash-bin":
      return <TrashBin classNames={classNames} />;
    case "solid-badge-info":
      return <SolidBadgeInfo classNames={classNames} />;
    default:
      return null;
  }
};

export default Icon;
